import React from 'react';
import styles from './style.module.scss';

export const BadVersion = () => (
    <section className={styles.section}>
        Widget&#39;s version is not available. Please, contact customer support.
    </section>
);
